import { render, staticRenderFns } from "./LeaveDetail.vue?vue&type=template&id=6893b511"
import script from "../../controllers/teacher_leave/leave-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_leave/leave-detail.js?vue&type=script&lang=js&external"
import style0 from "./LeaveDetail.vue?vue&type=style&index=0&id=6893b511&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports